import artifact from '$houdini/artifacts/UpdateVehicle'
import { MutationStore } from '../runtime/stores/mutation'

export class UpdateVehicleStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
